export const EVENTS = {
  HOME: {
    STATS: {
      REFRESH: 'home.stats.refresh',
      REFRESHING: 'home.stats.refreshing',
      REFRESHED: 'home.stats.refreshed',
      REFRESH_ERROR: 'home.stats.error'
    }
  }
};

export const ENDPOINTS = {
  HOME: {
    GET_STATS: '/api/users/{userId}/stats'
  }
};
